import { PaApi, baseOpts, processSuccess } from '@/services/PaApi'

export const NewsletterTypeModule = {
  namespaced: true,

  state: {
    newsletter_type: {},
    newsletter_types: []
  },

  getters: {
  },

  actions: {
    async getNewsletterTypes ({ commit, state }) {
      commit('setLoading', true, { root: true })

      await PaApi().get(
        '/admin/newsletter_types/'
      ).then((resp) => {
        commit('storeNewsletterTypes', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async getNewsletterType ({ commit, state }, newsletterTypeId) {
      commit('setLoading', true, { root: true })

      await PaApi().get(
        '/admin/newsletter_types/' + newsletterTypeId
      ).then((resp) => {
        commit('storeNewsletterType', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    }
  },

  mutations: {
    storeNewsletterType (state, payload) {
      state.newsletter_type = processSuccess(payload, baseOpts)
    },

    storeNewsletterTypes (state, payload) {
      state.newsletter_types = processSuccess(payload, baseOpts)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/NewsletterTypeModule.js